import { useMediaQuery } from './use-media-query'

export function useIsMobile(breakpoint = 1024) {
  return useMediaQuery(`(max-width: ${breakpoint - 1}px)`)
}
